import reports from "./reports";

export default function*() {
    yield* [...reports];
}
